import { render, staticRenderFns } from "./sso-configuration-card.vue?vue&type=template&id=61fcddbe&scoped=true"
import script from "./sso-configuration-card.vue?vue&type=script&lang=js"
export * from "./sso-configuration-card.vue?vue&type=script&lang=js"
import style0 from "./sso-configuration-card.vue?vue&type=style&index=0&id=61fcddbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fcddbe",
  null
  
)

export default component.exports